
var stringUtil = require('../../string/stringUtil.js');
const logger = require('../../logger/logger.js');
var rmsApiProxyRetry = require('../../api/rmsApiProxyRetry');
var dateUtil = require('../../dateUtil/dateUtil.js');
var stateManager = require('../../state/stateManager.js');
var displaySettingsUtils = require('../../domain/settings/displaySettingsUtils.js');
var viewUtil = require('../../view/viewUtil.js');

export function handleCliMessage(cliPayload, tracingContext)
{
    if (stringUtil.isStringNullOrEmpty(cliPayload.status))
    {
        logger.warn("CLI status is missing from message received from cli channel", tracingContext);
        return;
    }

    if (stringUtil.isStringNullOrEmpty(displaySettingsUtils.getCliNotificationPosition()))
        return;

    if (cliPayload.status == "open")
    {
        onOpenCallMessage(cliPayload, tracingContext);
    }

    if (cliPayload.status == "close")
        onCloseCallMessage(cliPayload, tracingContext);
}

function onOpenCallMessage(cliPayload, tracingContext)
{
    try
    {
        if (stringUtil.isStringNullOrEmpty(cliPayload.incomingNumber))
        {
            logger.warn("In coming number is missing in message received from cli channel.", tracingContext);
            return;
        }

        const metricStartTime = Date.now();
        logger.info(`Calling API to retrieve customer profile for incoming number: ${stringUtil.trimString(cliPayload.incomingNumber)}`, tracingContext);
        rmsApiProxyRetry.get(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/customers/${stringUtil.trimString(cliPayload.incomingNumber)}/cliProfile`)
        .then(cliResult =>
            {
                if (cliResult == null)
                {
                    logger.info(`Empty customer profile returned for incoming number: ${stringUtil.trimString(cliPayload.incomingNumber)}`, tracingContext);
                    cliResult = {};
                }

                logger.info(`Successfully retrieve customer profile for incoming number: ${stringUtil.trimString(cliPayload.incomingNumber)}`, tracingContext);
                const metricValueInMS = Date.now() - metricStartTime;
                logger.metrics(`CLI.PROFILE`, metricValueInMS, `Total time required to load customer profile from a CLI number`, tracingContext);

                cliResult.cliIncomingNumber = cliPayload.incomingNumber;
                cliResult.cliLine = cliPayload.line;
                cliResult.cliStatus = cliPayload.status;
                cliResult.dateTime = dateUtil.getNow();

                appendCliLogs(cliResult);
                viewUtil.showAlert("cli.notification", cliResult, cliResult.cliIncomingNumber);
                
            },  error =>
            {
                logger.error(`Error occurred while pulling CLI profile for customer with incoming number ${stringUtil.trimString(cliPayload.incomingNumber)}.`, tracingContext, error);
                this.setState({error: `Following error occurred while loading CLI from API Server. ${error}` });
            });
    }
    catch(error)
    {
        logger.error(`Following error occurred on handling Open Call CLI message. ${error}`, tracingContext, error);
    }
}

function onCloseCallMessage(cliPayload, tracingContext)
{
    viewUtil.clearAlertForId(cliPayload.incomingNumber);
}

function appendCliLogs(cliResult)
{
    let cliLogs = stateManager.getStore().getState().cliLogs;

    if (cliLogs.length >= 100)
    {
        cliLogs.pop()
    }
    
    cliLogs.splice(0, 0, cliResult);
}